<script>
  import { getContext } from 'svelte';
  import ProgramGeneral from '../forms/program.general';
  import ProgramPartner from '../forms/program.partner';
  import ProgramDetails from '../forms/program.details';
  import ProgramOther from '../forms/program.other';
  import { addNotification, ICONS } from '../../../../utils/notifications.store';

  import SectionNav from '../../../../components/navigation/section';
  import Link from '../../../../utils/link';
  import { UPDATE_PROGRAM, programValueToInput } from '../../../../graphql/programs';

  const client = getContext('apollo');

  export let value;
  let current = ProgramGeneral;

  function submit() {

  }

  function changeComponent(componentToChange) {
    current = componentToChange;
  }

  async function save() {
    const input = programValueToInput(value);
    input.id = value.id;
    delete input.communications;
    try {
      addNotification({ icon: ICONS.LOADING, message: `Saving ${input.name}` })
      await client.mutate({ mutation: UPDATE_PROGRAM, variables: { input } })
      addNotification({ icon: ICONS.SUCCESS, message: `Successfully Saved ${input.name}`, time: 2000 })
    } catch (e) {
      addNotification({ icon: ICONS.ERROR, message: `There was an error saving ${input.name}`, time: 2000 })
    }
  }

</script>

<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-9">
    <svelte:component this={current} bind:value={value} />
  </div>
  <div class="cell small-12 medium-3">
    <SectionNav hasSub={true}>
      <ul>
        <li class:active={current==ProgramGeneral} on:click={()=> changeComponent(ProgramGeneral)}>
          General
        </li>
        <li class:active={current==ProgramPartner} on:click={()=> changeComponent(ProgramPartner)}>
          Partner
        </li>
        <li class:active={current==ProgramDetails} on:click={()=> changeComponent(ProgramDetails)}>
          Details
        </li>
        <li class:active={current==ProgramOther} on:click={()=> changeComponent(ProgramOther)}>
          Other
        </li>
      </ul>
      <div on:click="{save}" class="save bottom">
        Save Program
      </div>
    </SectionNav>
  </div>
</div>